import { render, staticRenderFns } from "./PeriodSuggestionList.vue?vue&type=template&id=39a66697&scoped=true&"
import script from "./PeriodSuggestionList.vue?vue&type=script&lang=js&"
export * from "./PeriodSuggestionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a66697",
  null
  
)

export default component.exports